module.exports = "<p>\n  detail-profit works!\n</p>\n"